import { DiagnosticSheetResponse, StudentSkillsResponse } from "@edu/shared";
import { call } from "../../lib/api.ts";

/**
 * Две ручки панели «Где дыры» (6.1 и 6.2 docs/student-errors-design.md).
 *
 * Живут здесь, а не в `lib/api.ts`, по той же соседской причине, что справочник
 * тем формы выдачи (`homework/assign/topics-api.ts`): схемы нужны ровно одному
 * экрану. Базовый адрес, cookie и разбор отказов при этом общие, поэтому
 * наружу отсюда уезжает только `call`, а второго HTTP-клиента не заводится.
 *
 * ⚠️ **Ни одного импорта из `@edu/shared/oge/*`.** Диагноз считает сервер, сюда
 * приезжают готовые слова: название темы, класс, два числа, `label` с `remedy` и
 * текст `why` у ребра спуска (1.4 и 7.5 проекта).
 */

export function getStudentSkills(studentUserId: string): Promise<StudentSkillsResponse> {
  return call(`/v1/students/${studentUserId}/skills`, {}, StudentSkillsResponse);
}

/**
 * Состав диагностического листа по теме.
 *
 * ⚠️ Ученика ручка не принимает и принимать не должна: состав листа это свойство
 * графа и реестра, а не человека (6.2 проекта). Отсюда же следует, что её ответ
 * кэшируется на час у сервера и одинаков для всех.
 */
export function getDiagnosticSheet(skill: string): Promise<DiagnosticSheetResponse> {
  return call(
    `/v1/oge/diagnostic-sheet?skill=${encodeURIComponent(skill)}`,
    {},
    DiagnosticSheetResponse,
  );
}
